import Modal from 'bootstrap/js/dist/modal';

export default class YoutubeLink extends HTMLAnchorElement {
    constructor() {
        super();
        this.youtubeLink = this.dataset.youtubeLink;
        this.iframeVideoId = this.dataset.iframeVideoId;
        this.iframe = document.getElementById(this.iframeVideoId);
        this.modalVideoId = this.dataset.modalVideoId;
        this.modalElement = document.getElementById(this.modalVideoId);
    }

    connectedCallback() {
        this.modal = new Modal(this.modalElement);
        this.watch();
    }

    watch() {
        this.addEventListener('click', this.showModal.bind(this));
        this.modalElement.addEventListener('show.bs.modal', this.loadVideo.bind(this));
        this.modalElement.addEventListener('hide.bs.modal', this.stopVideo.bind(this));
    }

    showModal(e) {
        e.preventDefault();
        this.modal.show();
    }

    loadVideo() {
        this.iframe.src = this.youtubeLink;
    }

    stopVideo() {
        this.iframe.src = '';
    }
}
